import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "../../../components/FormInput";

const CusItemTypeNameTemplate = (option, props) => {
  if (option) {
    return (
      <div className="flex align-items-center">
        <div>{option?.typeName}</div>
      </div>
    );
  }
  return <span>{props.placeholder}</span>;
};

export const CusEvalItemComponent = ({
  register,
  errors,
  fieldName,
  inputCheckKeyDown,
  fields,
  handleResetForm,
  handleDelForm,
  index,
  action = "create",
  isReadOnly,
  evaluateItemList,
  control,
  setValue,
  getValues,
  rowData,
}) => {
  const { t } = useTranslation();

  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id: rowData.id,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    position: "relative",
    zIndex: isDragging ? 9999 : "auto",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} className="flex items-center justify-center pt-2 gap-2">
      <div className="flex items-center justify-center" style={{ width: "3rem" }}>
        <Button
          type="button"
          className="p-button-icon-only"
          icon="pi pi-bars"
          rounded
          text
          style={{ cursor: "grab" }}
          ref={setActivatorNodeRef}
          {...listeners}
        />
      </div>

      <div className="flex items-center justify-center w-full grid" style={{ minWidth: "20rem" }}>
          <div className="col-6">
            <Controller
              name={`${fieldName}`}
              control={control}
              rules={{
                validate: (value) => (value && value.typeSeq ? true : t("validation.required")),
              }}
              render={({ field, fieldState }) => (
                <Dropdown
                  filter
                  valueTemplate={CusItemTypeNameTemplate}
                  optionLabel="typeName"
                  value={evaluateItemList?.find((c) => c.typeSeq === getValues(field.name)?.typeSeq)}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  placeholder={t("plz_chs")}
                  control={control}
                  options={evaluateItemList}
                  className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                    setValue(fieldName, event.value, { shouldValidate: true });
                    setValue(`${fieldName}.displayName`, event.value?.displayName, { shouldValidate: true });
                  }}
                />
              )}
            />
          </div>
          <div className="col-6">
            <FormInput
              disabled={isReadOnly}
              register={register}
              errors={errors}
              id={`${fieldName}.displayName`}
              type="text"
              placeholder={t("evaluationTemplateName")}
              labelClass={`control-label required`}
              rules={{ required: t("validation.required") }}
              enterClick={(e) => {
                inputCheckKeyDown(e);
              }}
            />
          </div>
      </div>

      <div className="flex items-center justify-center" style={{ width: "3rem" }}>
        <Button
          type="button"
          className="p-button-icon-only"
          icon="pi pi-minus"
          rounded
          text
          onClick={() => {
            fields?.length === 1 ? handleResetForm(index) : handleDelForm(index);
          }}
        />
      </div>
    </div>
  );
};
